import { StackFrame } from 'react-native/Libraries/Core/Devtools/parseErrorStack';

export default async function symbolicateStackTrace(): Promise<StackFrame[] | null> {
  return null;
}